import { SVGAttributes } from 'react';

const Trukt = (props: SVGAttributes<SVGElement>) => (
  <svg
    version="1.1"
    id="Layer_1"
    xmlns="http://www.w3.org/2000/svg"
    x="0px"
    y="0px"
    viewBox="0 0 348 88.4"
    xmlSpace="preserve"
    role="img"
    {...props}
  >
    <title>Trukt Logo</title>
    <g id="a" />
    <g id="b">
      <g id="c">
        <g>
          <polygon className="st0" points="88.2,37.6 88,38.4 88.1,37.6" />
          <g>
            <path
              className="st1"
              d="M40.5,16.2l-4.1,15.3h33.9h15.8l4.1-15.2L40.5,16.2L40.5,16.2z M51.2,35.6l-9.3,34.5h18l9.3-34.5H51.2z"
            />
            <path
              className="st1"
              d="M264.3,16.2l-4.1,15.3h33.9h15.8l4.1-15.2C314,16.2,264.3,16.2,264.3,16.2z M275,35.6l-9.3,34.5h18
                            l9.3-34.5H275z"
            />
            <path
              className="st1"
              d="M139.4,33.2c0.8-21.4-29.9-16.5-45.1-17c-2.7,10-11.6,43.3-14.4,53.9h18l3.9-14.5l0,0
                            c1.7-6.2,4.9-18.1,6.5-24.3h6.4c11.9,0.5,6,12.3-4.8,10.5l-3.4,12.8l0,0l6,15.4h19.4l-7.4-17.9C135,48.8,139.4,41.6,139.4,33.2
                            L139.4,33.2z"
            />
            <path
              className="st1"
              d="M183.8,16.2c-2.2,5.7-7.3,33.1-11.6,36.8c-4.3,4.2-13.8,2.4-13.2-4.5c-0.5-2.1,7.6-29.5,8.2-32.2h-18.3
                            c-1.3,6.5-8.9,29.3-8.4,35.6c-2.1,21,32.3,24.8,44.6,12.3c8.8-7.4,13.2-37,17-47.9L183.8,16.2L183.8,16.2z"
            />
            <path
              className="st1"
              d="M237.7,46.2l-14.4,11.9l4.5,12H247L237.7,46.2L237.7,46.2z M238.4,16.2l-17.9,19.3l5.2-19.3h-18l-14.5,53.9
                            h18c3-11.8,1.7-8.8,10.2-17.3c9.6-6.9,30.5-27.9,38.9-36.6L238.4,16.2L238.4,16.2z"
            />
          </g>
        </g>
      </g>
    </g>
  </svg>
);

export default Trukt;
